// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VBtn: {
      style: { textTransform: "none" },
    },
    typography: {
      defaultFontFamily: "Inter",
    },
  },
});
export default vuetify;
